import React, { useState } from "react";
import "./Feedback.css";

function Feedback({ onClose, onVote }) {
  const [text, setText] = useState("");

  return (
    <div className="feedback-card">
      {/* NUEVO: encabezado con texto a la izquierda y "x" a la derecha */}
      <div className="feedback-header">
        <span className="feedback-title">Your feedback</span>
        <button className="feedback-close" onClick={onClose}>
          ×
        </button>
      </div>

      <textarea
        className="feedback-input"
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Your comment... (optional)"
        rows={3}
      />

      <span className="feedback-label">Rate to send</span>

      <div className="feedback-actions">
        <button
          className="feedback-btn-up"
          title="I like it"
          onClick={() => onVote("up", text.trim())}
        >
          <i className="bi bi-hand-thumbs-up" />
        </button>

        <button
          className="feedback-btn-down"
          title="I don't like it"
          onClick={() => onVote("down", text.trim())}
        >
          <i className="bi bi-hand-thumbs-down" />
        </button>

        <button
          className="feedback-btn-neutral"
          title="Neither good nor bad"
          onClick={() => onVote("neutral", text.trim())}
        >
          neither good<br />nor bad
        </button>
      </div>
    </div>
  );
}

export default Feedback;
